module.exports = __webpack_public_path__ + "static/media/heneel_photo.b2e6b776.jpeg";